<template>
    <div class="company-article" style="width: 100%;">
        <dl id="dl_en" class="hide" style="width: 100%;">
        <dd>The tyre has assumed a very important role in the driving characteristics and the general safety of vehicles. In order to make the best use of a tyre it is essential to understand its basic features properly. It is our belief that a through awareness of the basic features of a tyre will lay a firm foundation for its best use, such as in the fields of performance, proper usage, safety and economy. ARIVO sincerely hope that this web site, “Tyre Knowledge” will help you to improve your practical knowledge of the tyre’s function.</dd>
        <dt>Structure:</dt>
        <dd><img src="../../common/images/service/knowledge_1.png" height="300" style="margin-right: 20px;"><img src="@/common/images/service/knowledge_2.png" height="300"></dd>
        <dt>Load Index</dt>
        <dd>Refers to a single tyre load index under the condition of specified maximum load capacity.</dd>
        <table style="width: 100%;">
            <tr style="height: 35px; font-weight: bold; color: red; text-align: center;">
                <td style="width: 10%" class="tr-head">LI</td>
                <td style="width: 10%" class="tr-head">KG</td>
                <td style="width: 10%" class="tr-head">LI</td>
                <td style="width: 10%" class="tr-head">KG</td>
                <td style="width: 10%" class="tr-head">LI</td>
                <td style="width: 10%" class="tr-head">KG</td>
                <td style="width: 10%" class="tr-head">LI</td>
                <td style="width: 10%" class="tr-head">KG</td>
            </tr>
            <tr>
                <td>50</td>
                <td>190</td>
                <td>70</td>
                <td>335</td>
                <td>90</td>
                <td>600</td>
                <td>110</td>
                <td>1060</td>
            </tr>
            <tr>
                <td>51</td>
                <td>195</td>
                <td>71</td>
                <td>345</td>
                <td>91</td>
                <td>615</td>
                <td>111</td>
                <td>1090</td>
            </tr>
            <tr>
                    <td>52</td>
                    <td>200</td>
                    <td>72</td>
                    <td>355</td>
                    <td>92</td>
                    <td>630</td>
                    <td>112</td>
                    <td>1120</td>
            </tr>
            <tr>
                    <td>53</td>
                    <td>206</td>
                    <td>73</td>
                    <td>365</td>
                    <td>93</td>
                    <td>650</td>
                    <td>113</td>
                    <td>1150</td>
            </tr>
            <tr>
                    <td>54</td>
                    <td>212</td>
                    <td>74</td>
                    <td>375</td>
                    <td>94</td>
                    <td>670</td>
                    <td>114</td>
                    <td>1180</td>
            </tr>
            <tr>
                    <td>55</td>
                    <td>218</td>
                    <td>75</td>
                    <td>387</td>
                    <td>95</td>
                    <td>690</td>
                    <td>115</td>
                    <td>1215</td>
            </tr>
            <tr>
                    <td>56</td>
                    <td>224</td>
                    <td>76</td>
                    <td>400</td>
                    <td>96</td>
                    <td>710</td>
                    <td>116</td>
                    <td>1250</td>
            </tr>
            <tr>
                    <td>57</td>
                    <td>230</td>
                    <td>77</td>
                    <td>412</td>
                    <td>97</td>
                    <td>730</td>
                    <td>117</td>
                    <td>1285</td>
            </tr>
            <tr>
                    <td>58</td>
                    <td>236</td>
                    <td>78</td>
                    <td>425</td>
                    <td>98</td>
                    <td>750</td>
                    <td>118</td>
                    <td>1320</td>
            </tr>
            <tr>
                    <td>59</td>
                    <td>243</td>
                    <td>79</td>
                    <td>437</td>
                    <td>99</td>
                    <td>775</td>
                    <td>119</td>
                    <td>1360</td>
            </tr>
            <tr>
                    <td>60</td>
                    <td>250</td>
                    <td>80</td>
                    <td>450</td>
                    <td>100</td>
                    <td>800</td>
                    <td>120</td>
                    <td>1400</td>
            </tr>
            <tr>
                    <td>61</td>
                    <td>257</td>
                    <td>81</td>
                    <td>462</td>
                    <td>101</td>
                    <td>825</td>
                    <td>121</td>
                    <td>1450</td>
            </tr>
            <tr>
                    <td>62</td>
                    <td>265</td>
                    <td>82</td>
                    <td>475</td>
                    <td>102</td>
                    <td>850</td>
                    <td>122</td>
                    <td>1500</td>
            </tr>
            <tr>
                    <td>63</td>
                    <td>272</td>
                    <td>83</td>
                    <td>487</td>
                    <td>103</td>
                    <td>875</td>
                    <td>123</td>
                    <td>1550</td>
            </tr>
            <tr>
                    <td>64</td>
                    <td>280</td>
                    <td>84</td>
                    <td>500</td>
                    <td>104</td>
                    <td>900</td>
                    <td>124</td>
                    <td>1600</td>
            </tr>
            <tr>
                    <td>65</td>
                    <td>290</td>
                    <td>85</td>
                    <td>515</td>
                    <td>105</td>
                    <td>925</td>
                    <td>125</td>
                    <td>1650</td>
            </tr>
            <tr>
                    <td>66</td>
                    <td>300</td>
                    <td>86</td>
                    <td>530</td>
                    <td>106</td>
                    <td>950</td>
                    <td>126</td>
                    <td>1700</td>
            </tr>
            <tr>
                    <td>67</td>
                    <td>307</td>
                    <td>87</td>
                    <td>545</td>
                    <td>107</td>
                    <td>975</td>
                    <td>127</td>
                    <td>1750</td>
            </tr>
            <tr>
                    <td>68</td>
                    <td>315</td>
                    <td>88</td>
                    <td>560</td>
                    <td>108</td>
                    <td>1000</td>
                    <td>128</td>
                    <td>1800</td>
            </tr>
            <tr>
                    <td>69</td>
                    <td>325</td>
                    <td>89</td>
                    <td>580</td>
                    <td>109</td>
                    <td>1030</td>
                    <td>129</td>
                    <td>1850</td>
            </tr>
        </table>
        <br>
        <dt>Speed Index</dt>
        <dd>Refers to the tyre under load and air pressure to the standards set by the tyre can reach a top speed.</dd>
        <table style="width: 100%;">
            <tr style="height: 35px; font-weight: bold; color: red; text-align: center;">
                <td style="width: 10%" class="tr-head">Code</td>
                <td style="width: 10%" class="tr-head">Speed km/h</td>
                <td style="width: 10%" class="tr-head">Code</td>
                <td style="width: 10%" class="tr-head">Speed km/h</td>
                <td style="width: 10%" class="tr-head">Code</td>
                <td style="width: 10%" class="tr-head">Speed km/h</td>
            </tr>
            <tr>
                <td>M</td>
                <td>130</td>
                <td>S</td>
                <td>180</td>
                <td>W</td>
                <td>270</td>
            </tr>
            <tr>
                <td>N</td>
                <td>140</td>
                <td>T</td>
                <td>190</td>
                <td>Y</td>
                <td>300</td>
            </tr>
            <tr>
                <td>P</td>
                <td>150</td>
                <td>U</td>
                <td>200</td>
                <td>Z</td>
                <td>Over 240</td>
            </tr>
            <tr>
                <td>Q</td>
                <td>160</td>
                <td>H</td>
                <td>210</td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>R</td>
                <td>170</td>
                <td>V</td>
                <td>240</td>
                <td></td>
                <td></td>
            </tr>
        </table>
        <br>
        <dt>Labeling</dt>
        <dd>All new tyres, produced after 1st July 2012, and to be sold at point of sale in EU countries after 1st November 2012; must follow EC NO 1222/2009 labeling criteria, and should be labeled with stickers to give the information.</dd>
        <dd>The aim is to improve driving safety, fuel efficiency, and lower noise levels. This regulation allows consumers to make more informed choices when purchasing tires by considering these ranking.</dd>
        </dl>
        <dl id="dl_cn" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_es" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_ru" class="hide">
            <dd>test</dd>
        </dl>
    </div>
</template>
<script>
import $ from "jquery";
import Constants from "../../consts";
import VueCookies from "vue-cookies";
import consts from "../../consts";
export default {
  name: "Knowledge_Content",
  mounted: function() {
    $("#dl_en")
      .addClass("show")
      .removeClass("hide");
    // let lang = VueCookies.get(consts.COOKIE_LANG);
    // if (lang) {
    //   $("#dl_" + lang)
    //     .addClass("show")
    //     .removeClass("hide");
    // } else {
    //   $("#dl_en")
    //     .addClass("show")
    //     .removeClass("hide");
    // }
  }
};
</script>
<style>
.hide {
  display: none;
}
.show {
  display: block;
}
.sub_title {
  color: red;
}
table tr{
    /* background-color: black; */
    border-color: white;
    text-align: center;
}
table tr td{
    background-color: gray;
}
table tr td.tr-head{
    background-color: dimgray;
}
</style>




// WEBPACK FOOTER //
// src/components/service/knowledge_content.vue